<template>
    <div class="p-4">
        <l-l-selection class="mb-4" :networks="networks" @click="onShow"  />

        <l-info-box class="mb-4" :active="showGrid">Right click the grid to add, edit or delete calculated timeseries</l-info-box>

        <hot-table :data="calculated_timeseries" :settings="settings" v-show="showGrid" ref="hot">
            <hot-column title="Station" data="station" read-only="true"></hot-column>      
            <hot-column title="Primary" data="primary_pollutant" read-only="true"></hot-column>        
            <hot-column title="Operator" data="operator" read-only="true"></hot-column>
            <hot-column title="Secondary" data="secondary_pollutant" read-only="true"></hot-column>             
            <hot-column title="Result" data="result_pollutant" read-only="true"></hot-column>                   
            <hot-column title="Created by" data="createdby" read-only="true"></hot-column>                   
        </hot-table>

        <l-l-add :showing="add" @save="onSave" @close="onClose" :stations="stations"/>
        <l-l-edit :showing="edit" @save="onSave" @close="onClose" :stations="stations" :timeserie="tsSelected" />
    </div>
</template>


<script>
import CalculatedService from "@/helpers/services/processing/calculated.service";
import LLSelection from "./LLSelection";
import LInfoBox from "@/components/LInfoBox";
import Notify from "@/helpers/notify";
import LLAdd from "./LLAdd";
import LLEdit from "./LLEdit";

import ContextMenu from "./context.menu";
import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";

export default {
    name:"Calculated",
    components: {
        LLSelection,
        HotTable,
        HotColumn,
        LInfoBox,
        LLAdd,
        LLEdit
    },
    data() {
        return {
            add: false,
            edit:false,
            showGrid: false,
            networks: [],
            stations: [],
            netSelected: null,
            tsSelected: {},
            calculated_timeseries: [],            
            settings: HandsontableHelper.settings(false)
        };
    },
    mounted() {
        this.settings.afterSelectionEnd = this.selectRowOnly;
        this.settings.dropdownMenu = false;
        this.settings.contextMenu = ContextMenu(this);
        Notify.loadData(null, this.loadInitialData);
    },
    methods: {
        selectRowOnly(r, c, r2, c2) {
            if (this.manualSelection) {
                this.manualSelection = false;
                return;
            }
            const hot = this.$refs.hot.hotInstance;
            hot.deselectCell();
            this.manualSelection = true;
            hot.selectCells([[r, 0, r, hot.countCols() - 1]], false, false);
        },
        async loadInitialData() {
            this.networks = await CalculatedService.networks();  
        },

        async show(net_id) {
            this.netSelected = net_id;
            this.calculated_timeseries = await CalculatedService.calculated_timeseries(net_id);
            this.showGrid = true;
        },
        async onShow(net_id) {
            this.stations = this.networks.find((n) => n.value == net_id).stations;
            await Notify.loadData(null,this.show, net_id);            
        },
        async onAdd() {
            this.add = true;
        },
        async onSave(o) {
            if(o.id) {
                Notify.loadData("Updating calculated timeserie", this.update, o);   
            }
            else {
                Notify.loadData("Inserting calculated timeserie", this.insert, o); 
            }
        },
        async insert(o) {
            const res = await CalculatedService.insert(o);
            this.calculated_timeseries = await CalculatedService.calculated_timeseries(this.netSelected);
            Notify.success("Calculated timeserie added!");
        },
        async update(o) {            
            const res = await CalculatedService.update(o);
            this.calculated_timeseries = await CalculatedService.calculated_timeseries(this.netSelected);
            Notify.success("Calculated timeserie updated!");
        },
        async onClose() {
            this.add = false;
            this.edit = false;
            this.tsSelected = {};
        },
        onDelete (t, o) {
            if(o.length > 0) {
                const clickedRow = o[0].start.row;
                const hot = this.$refs.hot.hotInstance;
                const physicalIndex = hot.toPhysicalRow(clickedRow);
                let row = hot.getSourceDataAtRow(physicalIndex);

                Notify.prompt(async response => {
                if (response) {
                    await Notify.loadData(
                    "Please wait while deleting calculated timeserie",
                    async () => {
                        const rowsAffected = await CalculatedService.delete(row.id);
                        const activeEditor = hot.getActiveEditor();
                        hot.alter("remove_row", clickedRow, 1);
                        Notify.success("Calculated timeserie deleted!");
                    }
                    );
                }
                }, "This will delete the calculated timeserie. <br/><br/>Do you want to continue?");
            }
        },
        onEdit (t, o) {
            if(o.length > 0) {
                const clickedRow = o[0].start.row;
                const hot = this.$refs.hot.hotInstance;
                const physicalIndex = hot.toPhysicalRow(clickedRow);
                let row = hot.getSourceDataAtRow(physicalIndex);
                this.tsSelected = row;
                this.edit = true;
            }
        },
    }
}
</script>


<style lang="postcss">
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.10.2/css/all.min.css";
</style>